import { Component, Input } from "@angular/core"
import { FormsModule, ReactiveFormsModule } from "@angular/forms"
import { MatDialogRef, MatDialogModule } from "@angular/material/dialog"
import { GeoServiceService } from "@checkd-form/services/geo-service.service"

import { EmailWithRoles } from "@models/common"
import { PrimaryButtonDirective } from "../../next-ui/button/primary-button.directive"
import { MatRadioModule } from "@angular/material/radio"
import { MatFormFieldModule } from "@angular/material/form-field"
import { MatInputModule } from "@angular/material/input"
import { MatMenuModule } from "@angular/material/menu"
import { MatButtonModule } from "@angular/material/button"
import { CheckdAutocompleteEmailsComponent } from "../../checkd-ui/checkd-autocomplete-emails/checkd-autocomplete-emails.component"
import { MatIconModule } from "@angular/material/icon"
import { MatTabsModule } from "@angular/material/tabs"

enum SelectedTab {
  email,
}

@Component({
  selector: "app-company-invitation-dialog",
  templateUrl: "./company-invitation-dialog.component.html",
  styleUrls: ["./company-invitation-dialog.component.scss"],
  imports: [
    MatDialogModule,
    MatTabsModule,
    MatIconModule,
    CheckdAutocompleteEmailsComponent,
    MatButtonModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatRadioModule,
    PrimaryButtonDirective,
  ],
})
export class CompanyInvitationDialogComponent {
  emailInvitations: EmailWithRoles[] = []
  enableSMSInvitations: boolean = true
  selectedTab: SelectedTab = SelectedTab.email

  selectedRole: string = "DEFAULT"

  // Country code input
  @Input() phoneType: string
  // Default flag to show
  selectedCountryCode: string = "no"
  // What countries to have available in the list
  countryCodes = ["no", "se", "gb", "pl"]

  // Text area input
  textAreaInput: string = ""

  constructor(
    private dialogRef: MatDialogRef<CompanyInvitationDialogComponent>,
    // GeoService is for handling country codes
    public geoService: GeoServiceService,
  ) {}

  get canSendInvites() {
    return this.emailInvitations.length > 0
  }

  get inviteButtonMessage() {
    if (this.emailInvitations.length < 1) {
      // If on email tab
      if (this.selectedTab === SelectedTab.email) {
        return "Add an email to send invite"
      }
    }

    return `send ${this.emailInvitations.length} ${this.emailInvitations.length > 1 ? "invitations" : "invitation"}`
  }

  updateEmailInvites(mails: string[]) {
    this.emailInvitations = mails.map((email) => {
      return { email: email, roles: [this.selectedRole] } as EmailWithRoles
    })
  }

  updateSelectedRole() {
    this.emailInvitations.forEach((invitation) => (invitation.roles = [this.selectedRole]))
  }

  sendInvites() {
    if (this.selectedTab === SelectedTab.email) {
      this.dialogRef.close({
        emails: this.emailInvitations,
      })
    } else {
      throw new Error("Error sending invitation from selected tab")
    }
  }
}
